// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Tf4VW","rightAdornment":"Header_rightAdornment__uPBq-"};